<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
        {{ erro }}
      </div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>color_lens</mat-icon></div>
          <mat-card-title>Estoque</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar as entradas de estoque.
        </div>

        <table *ngIf="consultaRealizada" mat-table [dataSource]="listEstoque" class="full-width">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let estoque"> {{ estoque.id }} </td>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef> Data Entrada </th>
            <td mat-cell *matCellDef="let estoque"> {{ estoque.createdAt | date : 'dd/MM/yyyy HH:mm'}} </td>
          </ng-container>
          <ng-container matColumnDef="fornecedor">
            <th mat-header-cell *matHeaderCellDef> Fornecedor </th>
            <td mat-cell *matCellDef="let estoque"> {{ estoque.fornecedor }} </td>
          </ng-container>
          <ng-container matColumnDef="produto">
            <th mat-header-cell *matHeaderCellDef> Produto </th>
            <td mat-cell *matCellDef="let estoque"> {{ estoque.produto }} </td>
          </ng-container>
          <ng-container matColumnDef="qdtProduct">
            <th mat-header-cell *matHeaderCellDef> Quantidade </th>
            <td mat-cell *matCellDef="let estoque"> {{ estoque.qdtProduct }} </td>
          </ng-container>
          <ng-container matColumnDef="amountPaid">
            <th mat-header-cell *matHeaderCellDef> Total </th>
            <td mat-cell *matCellDef="let estoque"> {{ estoque.amountPaid | currency:'BRL' }} </td>
          </ng-container>
          <ng-container matColumnDef="excluir">
            <th mat-header-cell *matHeaderCellDef> Excluir </th>
            <td mat-cell *matCellDef="let estoque" (click)="$event.stopPropagation()">
              <button (click)="openDialog(estoque.id)" mat-icon-button color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <ng-container matColumnDef="editar">
            <th mat-header-cell *matHeaderCellDef> Editar </th>
            <td mat-cell *matCellDef="let estoque" (click)="$event.stopPropagation()">
              <button (click)="editar(estoque.id)" mat-icon-button color="accent">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
          <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
            (click)="editar(row.id)"></tr>
        </table>

        <mat-paginator *ngIf="consultaRealizada" [length]="totalElementos" [pageSize]="tamanho"
          [pageSizeOptions]="pageSizeOptions" (page)="paginar($event)">
        </mat-paginator>
      </mat-card>
    </div>
  </div>
</main>
